<template>
  <KeepAlive>
    <div class="freestyle-content-tab">
      <div class="content__wide-screen">
        <section class="content-slide-layouts" v-if="isNewTemplatesVisible">
          <ContentSlideTemplateCategories />
          <div class="content-slide-template-loader" v-if="isLoadingPublicSlideTemplates">
            <aha-spinner class="mb-2" />
            {{ $i18nPresenter.t('Loading templates…') }}
          </div>
          <div v-else>
            <div
              class="content-slide-template-list"
            >
              <ContentSlideTemplateItemV2
                v-for="(template) in templates"
                :key="template.id"
                :template="template"
                @click="applyTemplate(template)"
              />
            </div>
          </div>
        </section>
        <!-- For skoletube, they don't have new templates. Show the old layouts -->
        <section class="content-slide-layouts" v-else>
          <div class="content-slide-layout-list">
            <ContentSlideLayoutItem
              v-for="layout in ContentSlideLayouts"
              :key="layout.type"
              :layout="layout"
              @click="applyLayout(layout)"
            />
          </div>
        </section>
      </div>
      <div class="content__mobile-screen">
        <aha-icon name="laptop-and-pc" class="mb-3" maintainColor />
        <p>
          {{ $i18nPresenter.t('To edit this slide, please use a laptop or PC.') }}
        </p>
      </div>
    </div>
  </KeepAlive>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ContentSlideTemplateItemV2 from '@/components-v2/presentation-editor/freestyle/ContentSlideTemplateItemV2.vue'
import ContentSlideTemplateCategories from '@/components-v2/presentation-editor/freestyle/ContentSlideTemplateCategories.vue'
import ContentSlideLayoutItem from '@/components-v2/presentation-editor/freestyle/ContentSlideLayoutItem.vue'
import { ContentSlideLayouts, DefaultCanvasBlocks } from '@/utils/CanvasBlocksLayout'
import CanvasBlocksUpdateMixin from '@/mixins/presentation/CanvasBlocksUpdateMixin'
import ContentSlideTemplateMixin from '@/mixins/presentation/ContentSlideTemplateMixin'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
    ContentSlideTemplateItemV2,
    ContentSlideTemplateCategories,
    ContentSlideLayoutItem,
  },

  mixins: [CanvasBlocksUpdateMixin, UndoRedoMixin, ContentSlideTemplateMixin],
  data() {
    return {
      currentCanvasBlocks: null,
    }
  },

  computed: {
    ...mapGetters('contentSlideTemplates', ['publicSlideTemplates', 'categorySlideTemplates', 'isLoadingPublicSlideTemplates', 'contentSlideTemplateCategories']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),

    isNewTemplatesVisible() {
      return this.currentUser && this.currentUser.identifyProvider !== 'skoletube'
    },

    templates() {
      return this.categorySlideTemplates
    },
    dataCanvasBlocks() {
      if (this.slideActive.convertedFromDocument) {
        return {}
      }
      // Nếu có canvasBlock thì hiển thị
      // Nếu ko có canvasBlockUrl thì sẽ kiểm tra tới canvasBlock
      //  +Nếu canvasBlock cũng ko có thì sẽ kiểm tra tới titleHTML, bodyHTML của data slide content cũ
      if (!this.slideActive.canvasBlocksUrl) {
        const canvasBlocks = DefaultCanvasBlocks(this.slideActive.id)
        if (!this.slideActive.canvasBlocks) {
          Object.keys(canvasBlocks).forEach((blockId) => {
            const block = canvasBlocks[blockId]
            if (block.tag === 'heading' && this.slideActive.titleHTML) {
              canvasBlocks[blockId].content.value = this.slideActive.titleHTML
            }
            if (block.tag === 'content' && (this.slideActive.bodyHTML || this.slideActive.subheading)) {
              canvasBlocks[blockId].content.value = this.slideActive.bodyHTML || this.slideActive.subheading
            }
          })

          return canvasBlocks
        }
      }

      // Get the typing content of the block (not blur the block yet)
      const blocks = this.slideActive.canvasBlocks
      if (this.$store.state.blockContentCache) {
        Object
          .keys(this.$store.state.blockContentCache)
          .filter((cacheKey) => cacheKey.startsWith(`${this.slideActive.id}:`))
          .forEach((cacheKey) => {
            const blockId = cacheKey.split(':')[1]
            const block = blocks[blockId]
            if (block) {
              blocks[blockId].content.value = this.$store.state.blockContentCache[cacheKey]
            }
          })
      }
      return blocks
    },
  },

  created() {
    this.ContentSlideLayouts = ContentSlideLayouts
  },
  mounted() {
    this.registerHistory()
    this.getPublicSlideTemplatesAction()
  },
  destroyed() {
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    ...mapActions('contentSlideTemplates', ['getPublicSlideTemplatesAction']),

    backupBlocks(oldData, newData) {
      this.addActionToHistory({
        type: 'UpdateBlocks',
        data: oldData,
        newData,
        slideActiveId: this.slideActive.id,
      })
    },
    async restoreUpdateBlocks(data) {
      await this.updateCanvasBlocks(data, this.slideActive.id)
    },
    applyLayout(layout) {
      const oldCanvasBlocks = JSON.parse(JSON.stringify(this.dataCanvasBlocks))
      const newCanvasBlocks = layout.build(this.slideActive.id, this.dataCanvasBlocks)
      this.updateCanvasBlocks(newCanvasBlocks, this.slideActive.id)
      this.backupBlocks(oldCanvasBlocks, newCanvasBlocks)

      util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Content slide > Use layout', layout.name)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.freestyle-content-tab {
  .content__mobile-screen {
    @apply sm:mt-20 mt-12;
    display: none;

    text-align: center;
  }
}
.content-slide-layout-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.content-slide-template-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin-top: 2px;
}
.content-slide-template-loader {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
}

</style>
